/**
 * サービス状態チェック Composable
 *
 * - SERVICE_STATUS_API 環境変数が未設定の場合はスキップし、通常稼働として扱う（後方互換）
 * - API が 200 OK + is_active=true  → status: 'active'
 * - API が 200 OK + is_active=false → status: 'maintenance', message: DBのメッセージ
 * - API が応答しない / 非200（404以外） → status: 'down'
 * - API が 404                          → status: 'active'（旧バージョンAPI、後方互換）
 */

export type ServiceStatus = 'active' | 'maintenance' | 'down';

export interface ServiceStatusResult {
    status: ServiceStatus;
    message?: string;
}

export const useServiceStatus = () => {
    const config = useRuntimeConfig() as { public: Record<string, any> };

    const checkServiceStatus = async (): Promise<ServiceStatusResult> => {
        const endpoint = config.public.serviceStatusApi as string | undefined;

        // 環境変数未設定の場合はスキップ（既存環境への影響なし）
        if (!endpoint) {
            return { status: 'active' };
        }

        try {
            const res = await $fetch<{ is_active: boolean; message: string | null }>(endpoint, {
                method: 'GET',
            });

            if (res.is_active) {
                return { status: 'active' };
            }

            return {
                status: 'maintenance',
                message: res.message ?? undefined,
            };
        } catch (err: unknown) {
            // 404 = エンドポイントが存在しない旧バージョンのAPIサーバー → 稼働中として扱う（後方互換）
            if (err && typeof err === 'object' && 'status' in err && (err as { status: number }).status === 404) {
                return { status: 'active' };
            }
            // その他（ネットワークエラー / 5xx など）→ システム停止扱い
            return { status: 'down' };
        }
    };

    return { checkServiceStatus };
};
